/* eslint-disable @typescript-eslint/no-unsafe-member-access */

function updateOnlineStatus(status: number) {
  return function changeClass() {
    // replace with class name
    document.getElementsByTagName('html')[0].style.filter = status
      ? `grayscale(${status})`
      : 'inherit';
  };
}
const preloadedState = window.__PRELOADED_STATE__;

function addingListener(): void {
  window.addEventListener('online', updateOnlineStatus(0));
  window.addEventListener('offline', updateOnlineStatus(1));
  if (preloadedState && preloadedState.flags && preloadedState.flags.enablePwaInstall) {
    import('../../pwa/sw-activation')
      .then(module => {
        const { addListenerForPrompt } = module;
        addListenerForPrompt();
      })
      .catch(error => console.log('error loding SW activation', error));
  }
}

const entryPointSetup = (): void => {
  if (!navigator.onLine) {
    updateOnlineStatus(1)();
  }
  window.addEventListener('load', addingListener);
  if (preloadedState && preloadedState.flags && preloadedState.flags.enablePwaInstall) {
    import('../../pwa/sw-activation')
      .then(module => {
        const { initPWAGAEvent } = module;
        initPWAGAEvent();
      })
      .catch(error => console.log('error loding SW activation', error));
  }
};

export default entryPointSetup;
